import axiosInstance from "./axios-instance";


/**
* GET request to return a list of group types provided in Purapura DB
* @returns List of availeble group types
*/
const getGroupTypes = () => axiosInstance.get("/app/groups/types").then(res => res)

/**
 * GET request to provide Group graph data for a provided Group ID
 */
const getGroupInformationById = (id) => axiosInstance.get(`/app/groups/${id}`).then(res => res);


/**
 * GET request returns group members in a given group
 * @returns 
 */
const getGroupMembersByGroupId = (id) => axiosInstance.get(`/app/groups/${id}/members`).then(res => res);



const getAdditionalGroupInformationById = (id) => axiosInstance.get(`/app/groups/${id}/additional`).then(res => res);

const getGroupSessions = (id) => axiosInstance.get(`/app/groups/${id}/sessions`).then((res) => res);

const getActiveGroupMemberCount = (id) => axiosInstance.get(`/app/groups/${id}/active-member-count`).then((res) => res);

export default {
    getGroupTypes,
    getGroupInformationById,
    getGroupMembersByGroupId,
    getAdditionalGroupInformationById,
    getGroupSessions,
    getActiveGroupMemberCount
};